import { useState } from "react";
import emailjs from "@emailjs/browser";

const EMAILJS_SERVICE_ID = "service_fboeg38";
const EMAILJS_PUBLIC_KEY = "zoZZ3t0fSrCVNMZvK";
const TEMPLATE_CUSTOMER  = "template_knzx8yd";
const TEMPLATE_ADMIN     = "template_kzygcs9";

function Contact() {
  const [form, setForm] = useState({
    firstName: "", lastName: "", email: "",
    phone: "", interest: "", message: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const missing = [];
    if (!form.firstName.trim()) missing.push("First Name");
    if (!form.email.trim()) missing.push("Email Address");
    if (!form.interest || form.interest === "") missing.push("Interest");

    if (missing.length > 0) {
      setStatus({ type: "error", fields: missing });
      return;
    }

    setStatus("sending");

    const templateParams = {
      first_name: form.firstName,
      last_name:  form.lastName,
      name: form.firstName + " " + form.lastName, 
      email:      form.email,
      phone:      form.phone,
      interest:   form.interest,
      message:    form.message,
    };

    try {
      // Send customer confirmation email
      await emailjs.send(EMAILJS_SERVICE_ID, TEMPLATE_CUSTOMER, templateParams, EMAILJS_PUBLIC_KEY);
      
      // Try admin email separately — don't fail if this fails
      try {
        await emailjs.send(EMAILJS_SERVICE_ID, TEMPLATE_ADMIN, templateParams, EMAILJS_PUBLIC_KEY);
      } catch (adminErr) {
        console.warn("Admin email failed:", adminErr);
      }

      // ✅ Always show success if customer email sent
      setStatus("success");
      setForm({ firstName: "", lastName: "", email: "", phone: "", interest: "", message: "" });
    } catch (err) {
      console.error("EmailJS error:", err);
      setStatus("failed");
    }
  };

  return (
    <div>
      <div className="page-hero">
        <h1>Contact Ecoconnect</h1>
        <p>Get in touch for enquiries, partnerships and project consultations</p>
      </div>

      <div className="page-body">
        <div className="contact-wrapper">
          <div className="contact-info">
            <h3>Let's talk energy</h3>
            <p>
              Whether you have a project in mind, want to become a vendor,
              or are exploring our platform — our team is ready to help.
            </p>

            {[
              { icon: "📧", label: "Email", val: "aryan@ecoconnectservices.com" },
              { icon: "📞", label: "Phone", val: "+91 99585 50225" },
              {
                icon: "📍", label: "Location", val: (
                  <>
                    <span>• Ecoconnect COE & Infrastructure Lab, DLF Corporate Greens 512, Sector 74A, Gurugram, Haryana 122004, India</span>
                    <br /><br />
                    <span>• DCGI-1104, DLF Corporate Greens, Sector 74A, Gurugram, Haryana 122004, India</span>
                  </>
                )
              },
              { icon: "🕒", label: "Hours", val: "Mon–Sat: 9AM – 7PM IST" },
            ].map((item, i) => (
              <div className="contact-item" key={i}>
                <span className="contact-item-icon">{item.icon}</span>
                <div className="contact-item-text">
                  <strong>{item.label}</strong>
                  <span>{item.val}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="contact-form-box">
            <h3>Send us a message</h3>

            <div className="form-row">
              <div className="form-group">
                <label>First Name *</label>
                <input
                  type="text" name="firstName"
                  placeholder="James" value={form.firstName}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text" name="lastName"
                  placeholder="Mitchell" value={form.lastName}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Email Address *</label>
              <input
                type="email" name="email"
                placeholder="you@company.com" value={form.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="tel" name="phone"
                placeholder="+91 XXXXX XXXXX" value={form.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>I'm interested in *</label>
              <select name="interest" value={form.interest} onChange={handleChange}>
                <option value="" disabled>Select an option</option>
                <option value="EV Charging Solutions">EV Charging Solutions</option>
                <option value="Solar Systems">Solar Systems</option>
                <option value="IoT / Monitoring">IoT / Monitoring</option>
                <option value="Platform Partnership">Platform Partnership</option>
                <option value="Courses / Training">Courses / Training</option>
                <option value="Project Associate Role">Project Associate Role</option>
              </select>
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea
                rows="4" name="message"
                placeholder="Tell us about your project or enquiry..."
                value={form.message} onChange={handleChange}
              />
            </div>

            {/* ✅ Success */}
            {status === "success" && (
              <div style={{
                background: "#f0fdf4", border: "1.5px solid #bbf7d0",
                borderRadius: "10px", padding: "14px 18px",
                color: "#16a34a", fontSize: "14px", fontWeight: "600",
                marginBottom: "16px",
              }}>
                ✅ Message sent successfully! We'll get back to you soon.
              </div>
            )}

            {/* ❌ Validation Error */}
            {status?.type === "error" && (
              <div style={{
                background: "#fef2f2", border: "1.5px solid #fecaca",
                borderRadius: "10px", padding: "14px 18px",
                color: "#dc2626", fontSize: "14px", fontWeight: "600",
                marginBottom: "16px",
              }}>
                ❌ Please fill: {status.fields.join(", ")}
              </div>
            )}

            {/* ❌ Send Failed */}
            {status === "failed" && (
              <div style={{
                background: "#fef2f2", border: "1.5px solid #fecaca",
                borderRadius: "10px", padding: "14px 18px",
                color: "#dc2626", fontSize: "14px", fontWeight: "600",
                marginBottom: "16px",
              }}>
                ❌ Something went wrong. Please try again or email us directly.
              </div>
            )}

            <button
              className="btn-submit"
              onClick={handleSubmit}
              disabled={status === "sending"}
              style={{
                opacity: status === "sending" ? 0.7 : 1,
                cursor: status === "sending" ? "wait" : "pointer"
              }}
            >
              {status === "sending" ? "Sending... ⏳" : "Send Message ➜"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;